import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12 12.752q1.724.002 3.383.237c1.037.146 1.866.967 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75s-5.25-3.022-5.25-6.75c0-1.046.83-1.867 1.866-2.013A24 24 0 0 1 12 12.752m0 0c2.883 0 5.647.509 8.208 1.44a24 24 0 0 1-1.153 6.06M12 12.752c-2.883 0-5.647.509-8.208 1.44.125 2.105.52 4.136 1.153 6.06m7.055-7.5a2.25 2.25 0 0 0 2.248-2.354M12 12.753a2.25 2.25 0 0 1-2.248-2.354M12 8.253q1.494-.001 2.922-.236c.403-.065.74-.357.795-.762a3.8 3.8 0 0 0-.399-2.25M12 8.252q-1.493-.001-2.922-.236c-.402-.065-.74-.357-.795-.762a3.73 3.73 0 0 1 .4-2.253M12 8.252a2.25 2.25 0 0 0-2.248 2.146M12 8.253a2.25 2.25 0 0 1 2.248 2.146M8.683 5.002A6 6 0 0 1 7.528 4c.07-.63.27-1.222.574-1.747m.581 2.75a3.75 3.75 0 0 1 6.635.002m0 0c.427-.284.815-.62 1.155-1a4.5 4.5 0 0 0-.575-1.752M4.921 6.002a24 24 0 0 0-.392 3.315 24 24 0 0 0 5.223 1.082m9.327-4.397q.308 1.623.392 3.315a24 24 0 0 1-5.223 1.082"
    }, null, -1)
  ])))
}
export default { render: render }